module.exports = __webpack_public_path__ + "media/auto_history/kontrola_drogowa-8c7d257c.png";